import { required, regex, minValue, maxValue, minLength, maxLength } from "@jazasoft/mui-table";

// helpers
import { isTrue, isEmpty } from "./helpers";
import { DataType } from "./types";

const getTableValidation = validation => {
  if (isEmpty(validation)) return [];

  let validateList = [];
  if (isTrue(validation.required)) {
    validateList.push(required());
  }

  if (validation.dataType?.toLowerCase() === DataType.TEXT) {
    if (!isEmpty(validation.regex)) {
      validateList.push(regex(new RegExp(validation.regex), validation.regexError));
    }
    if (!isEmpty(validation.minLength)) {
      validateList.push(minLength(validation.minLength, `Must be ${validation.minLength} characters at least`));
    }
    if (!isEmpty(validation.maxLength)) {
      validateList.push(maxLength(validation.maxLength, `Must be at most ${validation.maxLength} characters`));
    }
  }

  if (validation.dataType?.toLowerCase() === DataType.NUMBER) {
    if (!isEmpty(validation.minValue)) {
      validateList.push(minValue(validation.minValue));
    }
    if (!isEmpty(validation.maxValue)) {
      validateList.push(maxValue(validation.maxValue));
    }
  }
  return validateList;
};

export default getTableValidation;
